module.exports = __webpack_public_path__ + "img/animationassist-en.569bc81.jpg";